import { useEffect, useState } from 'react';
import axios from 'axios';

export const useCSRF = () => {
  const [isTokenReady, setIsTokenReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    
    const initializeCSRF = async () => {
      try {
        // Make a GET request to the CSRF endpoint to initialize the token
        await axios.get('/health', {
          withCredentials: true,
          timeout: 5000,
          signal: controller.signal
        });
        setIsTokenReady(true);
      } catch (err: any) {
        // Don't log aborted requests as errors
        if (err.code !== 'ECONNABORTED' && err.code !== 'ERR_CANCELED') {
          console.error('Failed to initialize CSRF token:', err);
          setError('Failed to initialize security token');
        }
        // Still set as ready to not block the app
        setIsTokenReady(true);
      }
    };

    initializeCSRF();
    
    return () => {
      controller.abort();
    };
  }, []);

  return { isTokenReady, error };
};